import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import airbnb from "../../images/Airbnb_Logo.png";
import decolar from "../../images/decolar-logo.png";
import hoteis_com from "../../images/Hotels.com_logo.png";
import expedia from "../../images/expedia_logo.svg";
import booking from "../../images/booking_logo.svg";

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  border-top: 1px solid #eee;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #222;
`;

const Text = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 1.5rem;
`;

const Logos = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;
`;

const Logo = styled.img`
  height: 40px;
  object-fit: contain;

  @media (min-width: 768px) {
    height: 50px;
  }
`;

const ViewDivulgacao = () => {
  return (
    <Wrapper>
      <Content>
        <Title>
          Quer alugar seus períodos? <br />
          Eles ficarão em destaque nas maiores plataformas — sem esforço
        </Title>
        <Text>
          Ao cadastrar seu período com a gente, você ganha visibilidade real:
          além do nosso site próprio, sua cota pode ser divulgada em plataformas
          como <strong>Airbnb, Decolar, Hotéis.com, dentre outros</strong> e
          redes sociais — tudo para aumentar suas chances de aluguel.
        </Text>

        <Text>
          <strong>E o melhor:</strong> você não paga nada por isso. Só cobramos
          uma <strong>pequena comissão do hóspede</strong> se houver reserva. Ou
          seja, <strong>você só ganha</strong>.
        </Text>

        <Logos>
          <Logo src={airbnb} alt="Airbnb" />
          <Logo src={expedia} alt="Expedia" />
          <Logo src={decolar} alt="Decolar" />
          <Logo src={booking} alt="Booking" />
          <Logo src={hoteis_com} alt="Hoteis.com" />
        </Logos>
      </Content>
    </Wrapper>
  );
};

export default ViewDivulgacao;
